import React from 'react';
import { Hero } from './components/Hero';
import { EarlyTestimonials } from './components/EarlyTestimonials';
import { ProblemAgitation } from './components/ProblemAgitation';
import { ProductPresentation } from './components/ProductPresentation';
import { ModuleDetails } from './components/ModuleDetails';
import { BonusStack } from './components/BonusStack';
import { Urgency } from './components/Urgency';
import { PricingTiers } from './components/PricingTiers';
import { UpsellComparison } from './components/UpsellComparison';
import { MoreTestimonials } from './components/MoreTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="w-full min-h-screen bg-white font-sans text-brand-navy" data-id="element-0">
      <Hero data-id="element-1" />
      <EarlyTestimonials data-id="element-2" />
      <ProblemAgitation data-id="element-3" />
      <ProductPresentation data-id="element-4" />
      <ModuleDetails data-id="element-5" />
      <BonusStack data-id="element-6" />
      <Urgency data-id="element-7" />
      <PricingTiers data-id="element-8" />
      <UpsellComparison data-id="element-9" />
      <MoreTestimonials data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FAQ data-id="element-12" />
      <CostOfInaction data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />
      <SocialProofPopup data-id="element-16" />
    </div>;
}